var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FileUploader',{attrs:{"field":_vm.field,"field_data":_vm.field_data,"type":"file","multiple":_vm.field.options.multiple},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }